import { requestBuilder } from '../../../http/RequestBuilder';

export interface LinkTokenResponse {
    linkToken: string;
}

const useGetPinwheelLinkToken = requestBuilder.query<
    LinkTokenResponse,
    { bankAccountId: string }
>({
    queryKey: ({ bankAccountId }) =>
        `/api/direct-deposit/link-token/${bankAccountId}`,
    endpoint: ({ bankAccountId }) =>
        `/api/direct-deposit/link-token/${bankAccountId}`,
});
export default useGetPinwheelLinkToken;
